import React from "react"

export default function Delivery({className}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 53 31">
      <defs />
      <path fill="#E6282F" d="M44.306 11.39l-5.858-9.385a3.553 3.553 0 00-3.014-1.67H3.554A3.553 3.553 0 000 3.886v19.969a3.553 3.553 0 003.553 3.553h.932c.898 1.916 2.832 3.257 5.085 3.257 2.252 0 4.185-1.341 5.083-3.257h23.695c.898 1.916 2.832 3.257 5.085 3.257 2.25 0 4.185-1.341 5.082-3.257h.932A3.554 3.554 0 0053 23.856v-2.957c0-4.97-3.83-9.074-8.694-9.509zM9.578 27.367a2.325 2.325 0 110-4.65 2.325 2.325 0 010 4.65zm21.265-13.494V3.889h4.59l6.235 9.984H30.843zm12.589 13.494a2.325 2.325 0 110-4.65 2.325 2.325 0 010 4.65z"/>
    </svg>
  )
}